import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./App.scss";
import "./custom.css";
import App from "./App.jsx";
import Maintenance, { MAINTENANCE_MODE } from "./components/Maintenance.jsx";

import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import store from "./states/store";
import Idle from "react-idle";

if (window.location.pathname === "/" || window.location.pathname === "/about-us" || window.location.pathname === "/terms-conditions" || window.location.pathname === "/privacy-policy" || window.location.pathname === "/support"  ) {
  import("./CSS/App.css");
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const IDLE_USER_TIMEOUT = 1000 * 60 * 150000; // 15 minutes

const handleIdleUser = (idle) => {
  if (idle && localStorage.getItem("authToken")) {
    localStorage.removeItem("authToken");
    window.location.replace("/login");
  }
};

if (MAINTENANCE_MODE) {
  root.render(<Maintenance />);
} else {
  root.render(
    <Provider store={store}>
      <Idle
        timeout={IDLE_USER_TIMEOUT}
        onChange={({ idle }) => handleIdleUser(idle)}
      />
      <App />
    </Provider>
  );
}
